import React from "react";
import Headers from "../../../components/Headers";
import { Row, Col, Radio, Button } from "antd";
import NProgress from "nprogress";
import { fetchQuestionnaire } from "../../../api/grantRecord";
import "./index.scss";
const BreadCrumbData = [
  { path: "/page/ssry/userInfo", name: "试试如意" },
  { path: "/page/ssry/grantRecord", name: "派样记录" },
  { name: "查看问卷" },
];
class ViewQuestion extends React.Component {
  state = {
    info: {
      time: "",
      name: "",
      score: "",
      list: [],
    },
  };
  getDetails = () => {
    fetchQuestionnaire(this.props.match.params.id).then((res) => {
      if (res.success) {
        res.data.list.forEach((item) => {
          if (item.option) {
            try {
              item.options = JSON.parse(item.option);
              delete item.option;
            } catch (error) {}
          }
        });
        this.setState({
          info: res.data,
        });
      }
    });
  };
  componentDidMount() {
    NProgress.start();
    this.getDetails();
    NProgress.done();
  }
  renderQuestion = () => {
    const { list } = this.state.info;

    if (list) {
      return list.map((item1, index1) => {
        return (
          <div key={index1} className="item">
            <div className="title">
              {index1 + 1}.{item1.subject}
            </div>

            {item1.type === "Q&A" ? (
              <div style={{ maxWidth: 500 }}>{item1.answer}</div>
            ) : (
              <Radio.Group value={item1.choice}>
                {this.renderOptions(item1.options)}
              </Radio.Group>
            )}
          </div>
        );
      });
    }
  };
  renderOptions = (list) => {
    console.log(list);
    return list.map((item2, index2) => {
      return (
        <Radio className="radioStyle" key={index2} value={item2.label}>
          {item2.label}
        </Radio>
      );
    });
  };
  render() {
    const { info } = this.state;
    return (
      <div className="container">
        <Headers BreadCrumbData={BreadCrumbData}></Headers>
        <div className="viewQuestion_container">
          <Button
            style={{ marginBottom: 12 }}
            onClick={() => {
              this.props.history.go(-1);
            }}
          >
            返回
          </Button>
          <Row style={{ marginBottom: 8 }} className="card">
            <Col span={12}>
              <div className="name">{info.name}</div>
              <div className="time">{info.time}</div>
            </Col>
            <Col style={{ textAlign: "right" }} span={12}>
              <div className="score">
                {info.score}
                <span style={{ fontSize: 20 }}>分</span>
              </div>
              <div className="tips">系统评分</div>
            </Col>
          </Row>
          <div className="card">{this.renderQuestion()}</div>
        </div>
      </div>
    );
  }
}

export default ViewQuestion;
